import type { generated } from '@tempo-io/item-store-dto';
import type { z } from 'zod';

export type ItemType = z.infer<typeof generated.itemTypeSchema>;

export type ItemTypeMap = Record<number, ItemType>;

export type ItemTypeUpsert = z.infer<typeof generated.upsertItemTypeRequestSchema>;

export type ItemTypeLevel = z.infer<typeof generated.itemLevelSchema>;

export const sortItemTypesByLevel = (
  itemTypes: ItemType[],
  itemTypeLevels: ItemTypeLevel[],
): ItemType[] => {
  const levelById = new Map(itemTypeLevels.map((l) => [l.id, l.level]));
  return [...itemTypes].sort((a, b) => {
    const la = levelById.get(a.itemLevelId) ?? Number.MAX_SAFE_INTEGER;
    const lb = levelById.get(b.itemLevelId) ?? Number.MAX_SAFE_INTEGER;
    if (la !== lb) return la - lb;
    return a.name.localeCompare(b.name);
  });
};
